import React from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import TableInvoices from "../../orders/orderPayments/tableInvoices";
import TablePaymentsVaroExpress from "./tablePaymentsVaroExpress";

const AccordionPayments = ({
  values,
  formatNumberWithCommas,
  setPaymentTypes,
  paymentTypes,
  isAccountant,
  isAdmin,
  disabled
}) => {

  const isDisabled = () => false

  const renderBadges = (payed, invoiced) => {
    if (!payed && !invoiced) return null;
    const diff = payed - invoiced;
    return (
      <>
        {payed && (
          <span className="badge bg-success ms-2">
            PAGOS: ${formatNumberWithCommas(payed)}
          </span>
        )}
        {invoiced && (
          <span className="badge bg-success ms-2">
            FACTURADO: ${formatNumberWithCommas(invoiced)}
          </span>
        )}
        {payed &&
          invoiced &&
          (diff > 1 ? (
            <span className="badge bg-danger ms-2">
              POR FACTURAR: ${formatNumberWithCommas(diff)}
            </span>
          ) : diff <= 1 ? (
            <span className="badge bg-success ms-2">
              PAGOS COMPLETAMENTE FACTURADOS
            </span>
          ) : (
            <span className="badge bg-warning ms-2">
              FACTURAS EXCEDIDAS POR: ${formatNumberWithCommas(diff)}
            </span>
          ))}
      </>
    );
  };

  return (
    <div className="accordion" id="accordion">
      {/* Contado */}
      <div className="accordion-item border-0">
        <div className="accordion-header" id="headingOne">
          <button
            className="accordion-button bg-gray-900 text-white px-3 py-10px pointer-cursor collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseOne"
          >
            <i className="fa fa-circle fa-fw text-blue me-2 fs-8px"></i> Pagos y
            Facturación de CONTADO
            {renderBadges(values.contadoTotalPayed, values.contadoTotalInvoice)}
          </button>
        </div>
        <div
          id="collapseOne"
          className="accordion-collapse collapse"
          data-bs-parent="#accordion"
        >
          <div className="accordion-body bg-gray-100">
            <Row>
              <Col md="12">
                <h3>Contado</h3>
              </Col>
            </Row>
            <Row>
              {paymentTypes && (
                <>
                  <h5 className="mt-10px">
                    <i className="fa-solid fa-sack-dollar"></i> Pagos
                  </h5>
                  <TablePaymentsVaroExpress
                    //ref={tablePaymentsContadoRef}
                    paymentTypeCode="CONTADO"
                    tipoOrden="ordenVial"
                    destination_company="VaroExpress"
                    valuesKey="payments_contado"
                    disabled={disabled}
                  />
                  <h5 className="mt-10px">
                    <i className="fa-solid fa-file-invoice"></i> Facturas
                  </h5>
                  <TableInvoices
                    setPaymentTypes={setPaymentTypes}
                    paymentTypeCode="CONTADO"
                    valuesKey="invoices_contado"
                    nomenclaturaInicial="AA"
                    tipoOrden="ordenVial"
                    disabled={disabled}
                  />
                </>
              )}
            </Row>
          </div>
        </div>
      </div>

      {/* Crédito */}
      <div className="accordion-item border-0">
        <div className="accordion-header" id="headingTwo">
          <button
            className="accordion-button bg-gray-900 text-white px-3 pt-10px pb-10px pointer-cursor collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseTwo"
          >
            <i className="fa fa-circle fa-fw text-indigo me-2 fs-8px"></i> Pagos
            y Facturación a CRÉDITO
            {renderBadges(values.creditoTotalPayed, values.creditoTotalInvoice)}
          </button>
        </div>
        <div
          id="collapseTwo"
          className="accordion-collapse collapse"
          data-bs-parent="#accordion"
        >
          <div className="accordion-body bg-gray-100">
            <Row>
              <Col md="12">
                <h3>Crédito</h3>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                {paymentTypes && (
                  <>
                    <h5 className="mt-10px">
                      <i className="fa-solid fa-file-invoice"></i> Facturas
                    </h5>

                    <TableInvoices
                      setPaymentTypes={setPaymentTypes}
                      paymentTypeCode="CREDITO"
                      valuesKey="invoices_credito"
                      nomenclaturaInicial="BB"
                      tipoOrden="ordenVial"
                      disabled={disabled}
                    />
                    <h5 className="mt-10px">
                      <i className="fa-solid fa-sack-dollar"></i> Pagos
                    </h5>
                    <TablePaymentsVaroExpress
                      //ref={tablePaymentsCreditoRef}
                      tipoOrden="ordenVial"
                      destination_company="VaroExpress"
                      paymentTypeCode="CREDITO"
                      valuesKey="payments_credito"
                      disabled={disabled}
                    />
                  </>
                )}
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccordionPayments;
